import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { AddProductToCart } from '../../redux/Slices/CartSlice'
import notify from "./../UseNotification"

const UseAddProductToCart = (item) => {

    const { id } = useParams()
    const dispatch = useDispatch()
    const { addProductToCart } = useSelector(state => state.CartReducer)
    const [colorIndex, setColorIndex] = useState("")
    const [colorCode, setColorCode] = useState("")
    const [loading, setLoading] = useState(true)

    // to get color which user choose it
    const ColorValues = (index, color) => {
        setColorIndex(index)
        setColorCode(color)
    }

    // to handle add product to cart 
    const HandleAddToCart = async () => {
        if (item.availableColors.length >= 1) {
            if (colorCode === "") {
                notify("please choose color", "error")
                return;
            }
        } else {
            setColorCode(" ")
        }
        setLoading(true)
        await dispatch(AddProductToCart({
            productId: id,
            color: colorCode
        }))

        setLoading(false)
    }

    // handle add to cart request response
    useEffect(() => {
        if (loading === false) {
            if (addProductToCart && addProductToCart.status === 200) {
                notify("Product add successfuly", "success")
                window.location.reload(false)
            } else if (addProductToCart && addProductToCart.response.status === 500) {
                notify("You must login to add product to cart", "error")
            } else {
                notify(addProductToCart.response.data.message, "error")
            }
        }
    }, [loading])


    return [colorIndex, ColorValues, HandleAddToCart]
}

export default UseAddProductToCart
